import { WelcomeVideo } from "~/screens/Hub/Home/components/WelcomeVideo";
import { Slider } from "~/shared/components/ui/Slider/Slider";

export const WatchSection = () => (
  <section>
    <Slider
      title="Watch"
      items={[<WelcomeVideo key="welcome-video" showHeadings />]}
    />
  </section>
);
